export default __webpack_public_path__ + "static/media/XRC Logo.0392fb6c.png";